$(document).ready(function () {
    var slideIndex = 0;
    var slides = $(".slides-wrapper .slide");
    var dotsContainer = $(".dots");
    var dotsContaineres = $(".dotes");
    for (var i = 0; i < slides.length; i++) {
        dotsContainer.append(
            "<span class='dot w-[5px] h-[5px] mx-[5px] bg-[#CAD2DB] rounded-full cursor-pointer transition-colors duration-600 ease-linear' data-slide='" +
            i +
            "'></span>"
        );
    }
    for (var i = 0; i < slides.length; i++) {
        dotsContaineres.append(
            "<span class='dotsss w-[5px] h-[5px] mx-[5px] bg-[#CAD2DB] rounded-full cursor-pointer transition-colors duration-600 ease-linear' data-slide='" +
            i +
            "'></span>"
        );
    }
    showSlides();
    function showSlides() {
        var offset = -slideIndex * 100;
        $(".slides-wrapper").css("transform", "translateX(" + offset + "%)");
        $(".dot").removeClass("active").eq(slideIndex).addClass("active");
        $(".dotsss").removeClass("actives").eq(slideIndex).addClass("actives");
    }

    function nextSlide() {
        slideIndex = (slideIndex + 1) % slides.length;
        showSlides();
    }

    function prevSlide() {
        slideIndex = (slideIndex - 1 + slides.length) % slides.length;
        showSlides();
    }

    var slideInterval = setInterval(nextSlide, 3000);
    $(".slider").hover(
        function () {
            clearInterval(slideInterval);
        },
        function () {
            slideInterval = setInterval(nextSlide, 3000);
        }
    );

    // Click event for navigation dots
    $(document).on("click", ".dot", function () {
        slideIndex = $(this).data("slide");
        showSlides();
    });
    $(document).on("click", ".dotsss", function () {
        slideIndex = $(this).data("slide");
        showSlides();
    });
});

document.querySelectorAll(".likes").forEach((counter) => {
    let count = 0;
    const speed = 100;
    const states = [
        "Likes",
        "Followers",
        "Comments",
        "Views",
        "Auto Views",
        "Live Stream",
    ];
    let stateIndex = 0;

    function updateCounter() {
        count++;
        counter.innerText = `${count} ${states[stateIndex]}`;

        if (count >= 200) {
            count = 0;
            stateIndex++;
            stateIndex = stateIndex % states.length;
        }
        requestAnimationFrame(() => setTimeout(updateCounter, speed));
    }
    updateCounter();
});

$(document).on("click", ".quality_tabs", function () {
    var e = $(this).attr("data-id");
    var leng = $(".parent_quality").find(".quality_tabs").length;
    if (leng > 1) {
        $(".tab-content." + e)
            .find(".pricess")
            .removeClass("active");
        $(".tab-content." + e)
            .find(".tick_image")
            .removeClass("price-table");
        $(".tab-content." + e)
            .find(".tick_image")
            .first()
            .addClass("price-table");
        let firsttab = $(".tab-content." + e)
            .find(".pricess")
            .first();
        firsttab.click();
        $(".tab-content.active").not(".always-active").removeClass("active");
        $(".tab-content#" + e).addClass("active");
        activeTabb(
            $(".tab-content." + e)
                .find(".pricess")
                .find(".radio_q")
                .html(),
            e
        );
        var t = $(".tab-content." + e)
            .find(".pricess")
            .find(".radio_q")
            .html();
        $(".parent_quality .active").removeClass("active"),
            $(this).addClass("active");
    }
});

$(document).on("click", ".pricess", function () {
    var e = $(this);
    let quantity = e.attr("package-quantity");
    let price = e.attr("data-price");
    let oldPrice = e.attr("old-price");
    let searchBtn = $(".searchBtn");
    let detailsBtn = $("#view-details");
    const ctg = e.attr("ctg");
    let service = e.attr("service");
    let hrefData = searchBtn.attr("data-href").split("-");
    let variant = $(".pkg_variant").val() || null;

    detailsBtn.attr(
        "data-href",
        `${quantity}-${ctg}-${service}` + (variant ? `,${variant}` : "")
    );
    searchBtn.attr("data-href", `${quantity}-${hrefData[1]}-${service}`);
    let a = $(".quality_tabs.active").attr("data-id");
    $(".tab-content." + a)
        .find(".tick_image")
        .removeClass("price-table");
    e.find(".tick_image").addClass("price-table");
    e.parent().find(".pricess").removeClass("active");
    e.addClass("active");
    if (oldPrice && price) {
        $(".radio_discount").text(
            `Save Â£ ${(Number(oldPrice) - Number(price)).toFixed(2)}`
        );
    }
    $(".radio_price").text(`${price}`);
    $(".radio_oldPrice").text(`Â£${oldPrice}`);

    var t;
    let s = $(".tab-content." + a)
        .find(".active")
        .find(".radio_q")
        .html();

    activeTabb(
        $(".tab-content." + a)
            .find(".active")
            .find(".radio_q")
            .html(),
        a
    );
    if (variant) {
        // alert(variant);
        helperVariant(document.querySelector(".pkg_variant"));
    }
    return;
});

$(document).on("click", "#view-details", function () {
    const detailsHref = $(this).attr("data-href");
    const [quantity, ctg, serviceVariant] = detailsHref.split("-");
    const [service, variant] = serviceVariant.split(",");

    $("#quantity").val(quantity);
    $("#ctg").val(ctg);
    $("#service").val(service);
    $("#variant").val(variant || null);

    const formActionUrl = baseurl + `buy-${quantity}-${ctg}-${service}/`;
    $("#view-detail-form").attr("action", formActionUrl);
    $("#view-detail-form").submit();
});

document
    .querySelector("#review-submit")
    ?.addEventListener("click", function (event) {
        event.preventDefault();
        var s = $(this).closest("form")[0]; // Get the closest form element
        document
            .querySelectorAll(".errors")
            .forEach((error) => (error.textContent = ""));
        let name = $("#name").val()?.trim();
        let email = $("#email").val().trim();
        let message = $("#message").val().trim();
        let rating = $('input[name="stars"]:checked').val();
        let isValid = true;
        let firstInvalid;
        if (name === "") {
            isValid = false;
            document.getElementById("name_error").textContent = "Name is required.";
            firstInvalid = $("#name");
        }
        if (email === "") {
            isValid = false;
            document.getElementById("email_error").textContent = "Email is required.";
            if (!firstInvalid) {
                firstInvalid = $("#email");
            }
        } else if (!validateEmail(email)) {
            isValid = false;
            document.getElementById("email_error").textContent =
                "Invalid email format.";
            if (!firstInvalid) {
                firstInvalid = $("#email");
            }
        }
        if (!rating) {
            isValid = false;
            document.getElementById("rating_error").textContent =
                "Please select a rating.";
            if (!firstInvalid) {
                firstInvalid = $(".rating");
            }
        }
        if (message === "") {
            isValid = false;
            document.getElementById("message_error").textContent =
                "Review message is required.";
            if (!firstInvalid) {
                firstInvalid = $("#message");
            }
        }
        if (isValid) {
            if (typeof ser_id != "undefined" && ser_id !== null) {
                var sub_catg_id = ser_id;
            }

            $.ajax({
                url: base_url + "review/",
                type: "POST",
                data: {
                    name,
                    email,
                    rating,
                    message,
                    sub_catg_id,
                    [csrfName]: csrfHash,
                },
                dataType: "json",
                success: function (t) {
                    if (t.success) {
                        createToast("success", t.success);
                        resetForm();
                    } else {
                        createToast("error", error);
                    }
                },
                error: function (error) {
                    createToast("error", error);
                },
            });
        } else {
            if (firstInvalid) {
                firstInvalid.addClass("shake");
                firstInvalid[0].scrollIntoView({ behavior: "smooth", block: "center" });
                setTimeout(() => {
                    firstInvalid.removeClass("shake");
                }, 1200);
            }
        }
    });

function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
}
document.querySelectorAll('input[name="stars"]').forEach((radio) => {
    radio.addEventListener("change", function () {
        const selectedRating = this.value;
        document.querySelector(
            ".rating-counter span:first-child"
        ).textContent = `${selectedRating} / 5	`;
    });
});

function resetForm() {
    // Reset the form itself, which will clear all inputs (text, textarea, radio, etc.)
    document.querySelectorAll("form")?.forEach((e) => {
        e.reset();
    });

    // Clear all error messages dynamically
    document.querySelectorAll(".errors").forEach(function (errorSpan) {
        errorSpan.innerText = "";
    });

    // Reset star icons and rating counter dynamically
    document.querySelectorAll(".icon").forEach(function (star) {
        star.classList.add("text-[#BBBBBB]"); // Reset star color
        //star.classList.remove("text-transparent"); // Make stars visible
    });

    // Reset rating counter display
    document.querySelector(".rating-counter span").innerText = "0 / 5";
}

const wrapper = document.querySelector(".wrapper");
if (wrapper) {
    const e = document.querySelector(".carousel_1"),
        t = e?.querySelector(".card").offsetWidth,
        a = Math.round(e?.offsetWidth || 0);

    if (e) {
        let isDragging = false,
            startX,
            scrollLeft;

        // Detect touch device
        const isTouchDevice =
            "ontouchstart" in window || navigator.maxTouchPoints > 0;

        // Clone items for infinite scrolling
        const cloneItems = (items, position) =>
            items.forEach((item) => e.insertAdjacentHTML(position, item.outerHTML));
        cloneItems([...e.children].slice(-a).reverse(), "afterbegin");
        cloneItems([...e.children].slice(0, a), "beforeend");

        e.classList.add("no-transition");
        e.scrollLeft = e.offsetWidth;
        e.classList.remove("no-transition");

        // Arrow click functionality
        const arrows = document.querySelectorAll(".wrapper svg");
        arrows.forEach((arrow) => {
            arrow.addEventListener("click", () => {
                e.scrollLeft += arrow.id === "left" ? -t : t;
            });
        });

        // Handle infinite scroll behavior
        const handleInfiniteScroll = () => {
            if (e.scrollLeft === 0) {
                e.classList.add("no-transition");
                e.scrollLeft = e.scrollWidth - 2 * e.offsetWidth;
                e.classList.remove("no-transition");
            } else if (Math.ceil(e.scrollLeft) === e.scrollWidth - e.offsetWidth) {
                e.classList.add("no-transition");
                e.scrollLeft = e.offsetWidth;
                e.classList.remove("no-transition");
            }
        };

        // Dragging and touch functionality
        const startDrag = (event) => {
            isDragging = true;
            startX = isTouchDevice ? event.touches[0].pageX : event.pageX;
            scrollLeft = e.scrollLeft;
            e.classList.add("dragging");
        };

        const onDrag = (event) => {
            if (!isDragging) return;
            const x = isTouchDevice ? event.touches[0].pageX : event.pageX;
            const walk = x - startX;
            e.scrollLeft = scrollLeft - walk;
        };

        const stopDrag = () => {
            isDragging = false;
            e.classList.remove("dragging");
        };

        // Add event listeners for both touch and mouse
        e.addEventListener(isTouchDevice ? "touchstart" : "mousedown", startDrag);
        e.addEventListener(isTouchDevice ? "touchmove" : "mousemove", onDrag);
        e.addEventListener(isTouchDevice ? "touchend" : "mouseup", stopDrag);
        e.addEventListener(isTouchDevice ? "touchcancel" : "mouseleave", stopDrag);

        // Handle infinite scroll
        e.addEventListener("scroll", handleInfiniteScroll);
    }
}

let packageVariant = document.querySelector(".pkg_variant");
packageVariant?.addEventListener("change", (e) => helperVariant(e.target));
function helperVariant(element) {
    if (!element) return;
    let currentPackageQty = $(".pricess.active")
        .find(".pkg_prices")
        .text()
        .trim();
    let services = JSON.parse(all_service);
    let value = element.value;
    let allCountryVariants = [...document.querySelectorAll(".country-variant")];
    allCountryVariants.forEach(function (e) {
        if (value == e.value) {
            e.checked = true;
        } else {
            e.checked = false;
        }
    });
    let minServices = [];
    for (let i = 0; i < services.length; i++) {
        if (services[i].packageQty == currentPackageQty) {
            minServices = Object.values(services[i].variants)[0] || [];
            break;
        }
    }
    let priceToShow = $(".radio_price");
    minServices.forEach((e) => {
        if (e.variant_id == value) {
            priceToShow.text(`${e.pkg_price}`);
            $(".radio_oldPrice").text(`Â£${Number(e.previousPrice)}`);
            $(".radio_dicount").text(
                `Save Â£${(Number(e.previousPrice) - Number(e.pkg_price)).toFixed(2)}`
            );
        }
    });
    $("#view-details").attr(
        "data-href",
        `${$(".pricess.active").attr("package-quantity")}-${$(
            ".pricess.active"
        ).attr("ctg")}-${$(".pricess.active").attr("service")}` +
        (value ? `,${value}` : "")
    );
}

function ControlFlowRadios() {
    let allCountryVariants = [...document.querySelectorAll(".country-variant")];
    allCountryVariants.forEach((e) => {
        e.addEventListener("change", function () {
            let check = this.checked;
            if (check) {
                allCountryVariants.forEach(function (e) {
                    e.checked = false;
                });
                this.checked = true;
                packageVariant.value = this.value;
                helperVariant(packageVariant);
            } else {
                this.checked = false;
                let flag = allCountryVariants.some(function (e) {
                    return e.checked;
                });
                if (!flag) {
                    allCountryVariants[0].checked = true;
                    const changeEvent = new Event("change");
                    allCountryVariants[0].dispatchEvent(changeEvent);
                }
            }
        });
    });
}
ControlFlowRadios();
